import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import { Button, Spacer } from 'design-system';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectOnboardingTradingAccountForOnboardingFunnel } from 'features/invest/reducers/selectors';
import ProgressCard from './ProgressCard';
import { isWeb } from '../../../../constants';
const strings = {
    title: 'Make your first trade',
    titleSeccl: 'Make your first investment',
    desc: 'Discover more than 1,800 international stocks and start your investment journey. Capital at risk.',
    descSeccl: 'Discover 25+ ETFs & funds and start your investment journey. Capital at risk.',
};
const FirstTradeProgressCard = ({ status }) => {
    const dispatch = useAppDispatch();
    const account = useAppSelector(selectOnboardingTradingAccountForOnboardingFunnel);
    const hasFunded = account?.hasFunded;
    const broker = account?.account.broker;
    const hasMadeFirstTrade = account?.hasTraded;
    const navigation = useMainStackNavigation();
    const isActiveStep = status === 'ACTIVE' && hasFunded && !hasMadeFirstTrade;
    const handleFindStock = useCallback(() => {
        dispatch({
            type: 'ONBOARDING_FUNNEL_COMPLETED',
        });
        // The walkthrough points at the native tab bar, so web goes straight to the portfolio
        if (broker === 'seccl' && !isWeb) {
            navigation.navigateDeprecated('InvestWalkthroughModal');
        }
    }, [broker]);
    return (<ProgressCard lightBg lastItem completed={false} isActiveStep={isActiveStep} title={broker === 'seccl' ? strings.titleSeccl : strings.title}>
      <Text TextThin-14 Secondary>
        {broker === 'seccl' ? strings.descSeccl : strings.desc}
      </Text>
      {!!isActiveStep && (<>
          <Spacer h={12}/>
          <View style={styles.row}>
            <Button brandLight hug extra square title="Go to your portfolio" onPress={handleFindStock}/>
          </View>
        </>)}
    </ProgressCard>);
};
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
    },
});
export default FirstTradeProgressCard;
